export const ROUTES = {
  LOGIN: '/',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  OTP: 'verify-otp',
  DASHBOARD: '/dashboard',
  REPORTS: '/reports',
  ROLE: '/roles',
  ROLE_ACTIVE: '/roles/active',
  APPEARANCE: '/appearance',
  APPEARANCE_BRANDING: '/appearance/branding',
  USERS: '/users',
  USERS_ACTIVE: '/users/active',
  /** @deprecated use ROUTES.USERS_CREATE */
  CREATE_USER: '/users/create',
  USERS_CREATE: '/users/create',
  USER_DETAILS: '/users/:id',
  USER_MAP_ROLE: '/users/:id/map-role',
  SUPPORT: '/support',
  SETTINGS: '/settings',
  AKASHIC_LANDING: '/akashic-landing',
  AKASHIC_ADP_PIPELINE: '/akashic-data-pipeline',
  AKASHIC_AUD_UPLOAD: '/akashic-unstructured-data/upload',
  AKASHIC_AUD_LOGIN: '/akashic-unstructured-data/login',
  AKASHIC_AUD_FORGOT_PASSWORD: '/akashic-unstructured-data/forgot-password',
  AKASHIC_AUD_DASHBOARD: '/akashic-unstructured-data/dashboard',
  AKASHIC_AUD_REVIEW: '/akashic-unstructured-data/review/:id',
  AKASHIC_AUD_SUPPORT: '/akashic-unstructured-data/support',
  AKASHIC_AUD_SETTINGS: '/akashic-unstructured-data/settings',
  AKASHIC_AUD_NOTIFICATIONS: '/akashic-unstructured-data/notifications',
  COMING_SOON: '/coming-soon',
} as const

export type Route = (typeof ROUTES)[keyof typeof ROUTES]
